/*
 * fixparser
 * https://gitlab.com/logotype/fixparser.git
 *
 * Copyright © 2022 fixparser.io
 * Released under Commercial license. Check LICENSE.md
 */
export enum AllocPositionEffectEnum {
    Open = 'O',
    Close = 'C',
    Rolled = 'R',
    Fifo = 'F',
}
